import React from 'react';
import JSAlert from 'js-alert';
export function DGNForm(props){
  let styles = {
    dialog : {
      position : "absolute",
      width : "90%",
      top : "10px",
      left : "5%",
      backgroundColor : "rgb(239, 239, 239)",
      boxShadow : "rgba(0, 0, 0, 0.25) 0px 0px 20px 0px",
      borderRadius : "5px",
    }
  }
  var form = React.createRef();
  let saveTemplate = ()=>{
    JSAlert.confirm("Replace current template ?", "").then(function(result) {
      if (!result)
        return;
        let data={
          consignor : form.current.consignor.value,
          consignee : form.current.consignee.value,
          limitations : form.current.limitations.value,
          vessel: form.current.vessel.value,
          place_load: form.current.place_load.value,
          handling_info: form.current.handling_info.value,
          company_name : form.current.company_name.value,
          declarant : form.current.declarant.value
        }
        fetch(props.url+"api.php?data", {
      	  method: 'POST',
          mode: 'cors',
      	  credentials : 'include',
      		body : JSON.stringify({
            action : "dgn_template",
            data : data
          }),
      	})
    		 .then((response) => response.json())
    		 .then(
            (res) => {
            	props.createNotification(res.status,res.message)
          }).catch((error) => {
           	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
          });
      })
  }
  let checkData=(e)=>{
    if(form.current.boxes_count.value===""){
      e.preventDefault();
      props.createNotification('info',"Please enter number of boxes")
    }
    if(form.current.pallets_count.value===""){
      e.preventDefault();
      props.createNotification('info',"Please enter number of pallets")
    }
    return false;
  }
  let loadTemplate=()=>{
    fetch(props.url+"api.php?dgn_template", {
      method: 'GET',
      mode: 'cors',
      credentials : 'include',
    })
     .then((response) => response.json())
     .then(
        (res) => {
          props.createNotification(res.status,res.message)
          Object.keys(res.data).forEach((key)=>{
            form.current[key].value=res.data[key];
          })
      }).catch((error) => {
        if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
      });
  }
  return(
    <div style={styles.dialog}>
      <div className="container-fluid mt-2 mb-5">
      <form action={props.url+"dgn_pdf.php"} method="POST" ref={form} onSubmit={(e)=>checkData(e)}>
        <div className="btn-group">
          <button className="btn btn-primary" type="submit" target="#output"><i className="fa fa-print"/> Print</button>
          <button className="btn btn-danger" type="button" onClick={()=>props.hideDGNForm()}><i className="fa fa-times"/> Close</button>
          <button className="btn btn-secondary" type="button" onClick={()=>loadTemplate()}><i className="fa fa-save"/> Load template</button>
          <button className="btn btn-success" type="button" onClick={()=>saveTemplate()}><i className="fa fa-save"/> Save template</button>
        </div>
          <p className="text-center">MULTIMODAL DANGEROUS GOODS FORM</p>

          <div className="form-group col-6">
            <label className="control-label">1 Shipper/Consignor/Sender</label>
            <textarea name="consignor" className="form-control"></textarea>
          </div>
          <div className="form-group col-6">
            <label className="control-label">6 Consignee</label>
            <textarea name="consignee" className="form-control"></textarea>
          </div>
          <div className="form-group col-12">
            <label className="control-label">8 This shipment is within the limitations prescribed for</label>
            <div>
              <label>
                <input type="radio" name="limitations" value="Passanger and Cargo Aircraft"/> Passanger and Cargo Aircraft
              </label>
              <br/>
              <label>
                <input type="radio" name="limitations" value="Cargo Aircraft Only"/> Cargo Aircraft Only
              </label>
            </div>
          </div>
          <div className="col-12">
            <div class="row">
              <div className="form-group col-3">
                <label className="control-label">10 Vessel</label><br/>
                <input type="text" name="vessel"/>
              </div>
              <div className="form-group col-3">
                <label className="control-label">11 Port/Place of loading</label><br/>
                <input type="text" name="place_load"/>
              </div>
              <div className="form-group col-6">
                <div className="form-group">
                  <label className="control-label">9 Additional handling information</label>
                  <textarea name="handling_info" className="form-control">Emergency Contact:</textarea>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            14 Shipping marks
            <div className="row">
              <div className="col-4">
              <div className="form-group">
                <label className="control-label">*Number and kind of packages; description of goods</label>
                 <textarea className="form-control" type="text" name="description" rows={7}
                />
              </div>
              </div>
              <div className="col-2">
              <div className="form-group">
                <label className="control-label">Number of boxes</label>
                 <input className="form-control" type="text" name="boxes_count" />
              </div>
              <div className="form-group">
                <label className="control-label">Number of pallets</label>
                 <input className="form-control" type="text" name="pallets_count" />
              </div>
              </div>
              <div className="col-2">
              <div className="form-group">
                <label className="control-label">Gross mass (kg)</label>
                <input className="form-control" name="gross"/>
              </div>
              </div>
              <div className="col-2">
              <div className="form-group">
                <label className="control-label">Net mass</label>
                <input className="form-control" name="net"/>
              </div>
              </div>
              <div className="col-2">
              <div className="form-group">
                <label className="control-label">Cube (m3)</label>
                <input className="form-control" name="cube"/>
              </div>
              </div>
            </div>
          </div>
          <div className="form-group col-6">
            <label className="control-label">20 Name of Company</label>
            <input type="text" name="company_name" className="form-control"/>
          </div>
          <div className="form-group col-6">
            <label className="control-label">Name/status of declarant</label>
            <input type="text" name="declarant" className="form-control"/>
          </div>
          <div className="form-group col-6">
            <label className="control-label">Place and Date</label>
            <input type="place_date" name="place_date" className="form-control"/>
          </div>
        </form>
      </div>
    </div>
  )
}
